var Handlebars = require("D:\\AVA\\code\\jwplayer\\JWP\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<li id=\"d_"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\"><a class=\"cue-dot-area\" href=\"javascript:void(0);\" > <i class=\"cue-dot\" style=\"border-bottom-color:#"
    + alias2(alias1((depths[1] != null ? depths[1].bg : depths[1]), depth0))
    + ";\"></i></a>\r\n<a href=\"javascript:void(0);\" class=\"cue-dot-info\" >"
    + alias2(alias1((depth0 != null ? depth0.title : depth0), depth0))
    + " <span class=\"cue-seektime\">["
    + alias2(__default(require("D:\\AVA\\code\\jwplayer\\JWP\\src\\webpack\\helpers\\digits.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.seekTime : depth0),{"name":"digits","hash":{},"data":data}))
    + "]</span></a>\r\n</li>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div class=\"cue-dots-wrapper\">\r\n\r\n<ul class=\"cue-dots\" id=\"cue_dots_"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.o : depth0)) != null ? stack1.container_id : stack1), depth0))
    + "\">\r\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.cuePointsArr : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true,"useDepths":true});


//////////////////
// WEBPACK FOOTER
// ./src/webpack/templates/cuehelper_cue-dots.handlebars
// module id = 25
// module chunks = 0 1